// extracted by mini-css-extract-plugin
module.exports = {"arrowIcon":"CustomPagination_arrowIcon__1MtQR","disabled":"CustomPagination_disabled__yZDA8","pagination":"CustomPagination_pagination__1uc_Y"};